module.exports = __webpack_public_path__ + "img/credit-card-upload.3f2289c3.svg";